import { forwardRef, type InputHTMLAttributes, type TextareaHTMLAttributes, type SelectHTMLAttributes } from 'react'
import { classNames } from '@/lib/utils'

const baseStyles =
  'block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 disabled:bg-gray-50 disabled:text-gray-500'

/** @deprecated Use `Input` from `@/components/Input` (Tremor Raw) instead. See ADM-507. */
export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => <input ref={ref} className={classNames(baseStyles, className)} {...props} />,
)
Input.displayName = 'Input'

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...props }, ref) => (
    <textarea ref={ref} className={classNames(baseStyles, 'resize-none', className)} {...props} />
  ),
)
Textarea.displayName = 'Textarea'

/** @deprecated Use `Select` from `@/components/Select` (Tremor Raw, Radix-based) instead. See ADM-507. */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, ...props }, ref) => <select ref={ref} className={classNames(baseStyles, className)} {...props} />,
)
Select.displayName = 'Select'
